class CountingAnimation extends HTMLElement {
  constructor() {
    super();
    this.animated = false;
    this.observer = null;
  }

  connectedCallback() {
    const counter = this.querySelector('.counter-number');
    if (!counter) return;
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.animated) {
          this.startAnimation();
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });

    this.observer.observe(this);
  }

  startAnimation() {
    const counter = this.querySelector('.counter-number');
    if (!counter) return;

    this.classList.add('animate');
    this.animated = true;

    const delay = parseInt(counter.getAttribute('data-delay')) || 0;
    
    if (delay > 0) {
      setTimeout(() => {
        this.animateCounter(counter);
      }, delay);
    } else {
      this.animateCounter(counter);
    }
  }

  animateCounter(counter) {
    const target = parseInt(counter.getAttribute('data-target'));
    const startValue = parseInt(counter.getAttribute('data-start')) || 0;
    const duration = parseInt(counter.getAttribute('data-speed')) || 2000;
    const startTime = performance.now();
    
    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const range = target - startValue;
      const current = Math.floor(startValue + (easeOutQuart * range));
      
      counter.textContent = current;
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        counter.textContent = target;
      }
    };
    
    requestAnimationFrame(updateCounter);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('counting-animation', CountingAnimation);
